module.exports = __webpack_public_path__ + "img/stepup_card.4bd969cb.svg";